<template>
  <Navbar homeviewsubpage logourl="/rental/home" />

  <section id="orderDevice">
    <div class="container pt-5" data-aos="fade-up">
      <div class="section-caption">
        <h2>
          <img src="../assets/images/payments.png" alt="" />&nbsp;{{
            rentalDeviceSerialNumbers !== null
              ? "Przedłuż abonament"
              : "Zamów urządzenie z abonamentem"
          }}
        </h2>
      </div>
      <Alert
        v-if="gusDataNotActive"
        alert-type="alert-warning"
        alert-text="Dane klienta z bazy danych GUS są nieaktualne. Wyślij oświadczenie do zmiany danych w systemie lub załóż nowe konto na aktywne dane."
        class="mt-2"
      />
      <Alert
        v-if="gusDataError"
        alert-type="alert-warning"
        alert-text="Nie udało się pobrać danych o działalności gospodarczej z bazy GUS."
        class="mt-2"
      />
      <div class="section-content">
        <div class="row mt-3">
          <div class="col">
            <div class="tile">
              <p>Numer użytkownika: {{ userIdNum }}</p>
              <p v-if="rentalDeviceSerialNumbers !== null">
                Numer seryjny urządzenia:
                {{
                  rentalDeviceSerialNumbers.serialLong === null
                    ? rentalDeviceSerialNumbers.serialShort
                    : rentalDeviceSerialNumbers.serialLong
                }}
              </p>
              <div class="input-group mb-3" style="height: 1.5rem">
                <input
                  type="number"
                  v-model="expandPeriod"
                  min="0"
                  max="12"
                  step="1"
                  onkeypress="return (event.charCode >= 48 && event.charCode <= 57)"
                  name="extendSubLength"
                  @input="
                    expandPeriod > 12 || expandPeriod <= 0
                      ? (expandPeriod = null)
                      : {}
                  "
                  class="form-control"
                  autocomplete="off"
                  onpaste="return false"
                  ondrop="return false"
                  placeholder="Długość abonamentu w miesiącach"
                  required
                />
              </div>

              <br>

              <div id="payment_calculation">
                <p>Opłata miesięczna za abonament:</p>
                <p>
                  <b
                    >{{ subscriptionPrice }} PLN netto /
                    {{ round2dec(subscriptionPrice) * vatRatio }} PLN brutto
                    (VAT 23%)</b
                  >
                </p>

                <div v-if="orderContinuation === 0">
                  <p>Opłata aktywacyjna:</p>
                  <p>
                    <span
                      v-if="
                        activationPricePromo === null ||
                        activationPricePromo === undefined
                      "
                      ><b
                        >{{ activationPrice }} PLN /
                        {{ round2dec(activationPrice * vatRatio) }} PLN brutto
                        (VAT 23%)</b
                      ></span
                    >
                    <span v-else class="strikethrough"
                      ><b>{{ activationPrice }} PLN</b></span
                    >

                    <span
                      v-if="
                        activationPricePromo === null ||
                        activationPricePromo === undefined
                      "
                    ></span>
                    <span v-else style="color: red"
                      ><b
                        >{{ activationPricePromo }} PLN netto
                        <span style="color: #2c3e50"
                          >/
                          {{ round2dec(activationPricePromo * vatRatio) }} PLN
                          brutto (VAT 23%)</span
                        ></b
                      ></span
                    >
                  </p>
                </div>
                <p>Opłata całkowita:</p>
                <p>
                  <b>
                    {{ round2dec(calculatePayment(expandPeriod)) }} PLN netto /
                    {{ round2dec(calculatePayment(expandPeriod) * vatRatio) }}
                    PLN brutto (VAT 23%)</b
                  >
                </p>
              </div>
              <div class="input-group-text mb-3 text-start">
                <label class="text-wrap"
                  ><input
                    type="checkbox"
                    v-model="userDataAgreement"
                    name="userDataAgreement"
                    class="form-check-input checkbox-blue mt-1"
                    :class="[
                      this.userDataAgreement === null ||
                      this.userDataAgreement === false
                        ? 'is-invalid'
                        : 'is-valid',
                    ]"
                    placeholder=""
                    value="userDataAgreement"
                    required
                  />
                  <span style="color: red; margin-left: 0.25rem">*</span>
                  Oświadczam, że zamawiany abonament będę wykorzystywał do celów
                  związanych z prowadzoną działalnością gospodarczą lub świadczę
                  usługi w ramach działalności zawodowej. Dane podane przy
                  rejestracji odnoszą się do <b>aktywnej</b> prowadzonej
                  działalności
                </label>
              </div>
            </div>
          </div>
          <div id="payment_choose" class="col">
            <div class="row">
              <div class="form-group">
                <p>Wybierz sposób płatności:</p>
              </div>
              <div
                v-if="rentalDeviceSerialNumbers !== null || nextDeviceTrigger"
                class="col"
              >
                <div class="tile">
                  <div class="card-body">
                    <p class="card-text text-center">
                      <b>
                        <label class="text-wrap"
                          ><input
                            type="radio"
                            v-model="paymentChoice"
                            name="paymentChoice"
                            class="form-check-input radio-blue mt-1"
                            placeholder=""
                            value="dotPay"
                          />
                          Szybkie płatności
                        </label>
                      </b>
                    </p>
                    <p class="card-text text-center">
                      <img
                        class="logo"
                        style="width: 150px"
                        src="../assets/images/Przelewy24_logo.png"
                        alt=""
                      />
                    </p>
                  </div>
                </div>
              </div>
              <div class="col">
                <div class="tile">
                  <p class="align-center">
                    <b>
                      <label class="text-wrap"
                        ><input
                          type="radio"
                          v-model="paymentChoice"
                          name="paymentChoice"
                          class="form-check-input radio-blue mt-1"
                          placeholder=""
                          value="traditionalTransfer"
                        />
                        Przelew tradycyjny
                      </label>
                    </b>
                  </p>
                  <p class="align-center">
                    <img
                      class="logo"
                      style="height: 53px; width: 53px"
                      src="../assets/images/bank_transfer_icon_137913.png"
                      alt=""
                    />
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <Alert
          v-if="orderFailure"
          alert-type="alert-danger"
          alert-text="Próba przedłużenia abonamentu zakończona niepowodzeniem. Skontaktuj się z pomocą techniczną."
        />
        <Alert
          v-if="invalidSubscriptionLength"
          alert-type="alert-danger"
          :alert-text="invalidSubscriptionLengthAlertText()"
        />
      </div>
      <div class="row mt-3">
        <div class="text-center">
          <button
            type="button"
            id="logButton"
            class="btn-standard m-2"
            @click="onBackButtonClick"
          >
            Wstecz
          </button>
          <button
            class="btn-standard"
            :disabled="
              expandPeriod === null ||
              expandPeriod <= 0 ||
              expandPeriod === '' ||
              paymentChoice === null ||
              paymentChoice === '' ||
              paymentChoice === undefined ||
              userDataAgreement === null ||
              userDataAgreement === undefined ||
              !userDataAgreement
            "
            @click="onExtendSubscriptionButtonClick($event)"
          >
            {{
              rentalDeviceSerialNumbers !== null
                ? "Przedłuż abonament - do płatności"
                : "Zamów urządzenie z abonamentem - do płatności"
            }}
          </button>
        </div>
      </div>
    </div>
    <!-- Stopka -->
    <Footer />
  </section>
</template>

<script>
import Alert from "@/components/Alert.vue";
import { RequestResult } from "@/utils/requestResult";
import store from "@/store";
import { round2dec, makeRequest, scrollToTop } from "@/utils/helpers";
import Footer from "@/components/Footer.vue";
import Navbar from "@/components/Navbar.vue";

export default {
  name: "SubscriptionHandleView",

  components: {
    Navbar,
    Footer,
    Alert,
  },

  data() {
    return {
      userId: null,
      userIdNum: null,
      rentalDeviceSerialNumbers: null,
      paymentAmount: null,
      expandPeriod: null, // wpisywana wartość do inputa
      expandMonths: null, // obliczona wartość miesięcy przedłużenia przekazywana do zapytania o zamówienie
      orderContinuation: null,
      userData: null,

      paymentChoice: null,
      userDataAgreement: null,

      gusDataError: null,
      gusDataNotActive: null,
      gusDataAvailable: null,

      additionalMonthsInfo: false,

      orderFailure: null,
      invalidSubscriptionLength: null,
      subscriptionAvailableMonths: -1,

      subscriptionPrice: null,
      //subscriptionDays: null,
      activationPrice: null,
      activationPricePromo: null,

      nextDeviceTrigger: null,
    };
  },

  async created() {
    scrollToTop();

    await this.getUserData();
    if (this.userData) {
      this.userId = this.userData.id;
      this.userIdNum = this.userData.useridnum;
    }

    let deviceData = await this.getDeviceData();
    if (deviceData) {
      let deviceSerialNumberIndex = store.state.rentalDeviceIndex;
      if (deviceSerialNumberIndex !== null) {
        this.rentalDeviceSerialNumbers = JSON.parse(
          JSON.stringify({
            serialShort: deviceData[deviceSerialNumberIndex].serial,
            serialLong: deviceData[deviceSerialNumberIndex].serial2,
          })
        );
      }
    }

    this.orderContinuation = store.state.orderContinuation ?? 0;
    this.nextDeviceTrigger = store.state.nextDeviceTrigger;

    if (this.rentalDeviceSerialNumbers === null && !this.nextDeviceTrigger)
      // zaznacz domyślnie przelew jesli nie ma przypisanego urzadzenia
      this.paymentChoice = "traditionalTransfer";
    else this.paymentChoice = null;

    let dotPayPaymentCounter = store.state.dotPayPaymentCounter;
    if (dotPayPaymentCounter > 1) {
      store.commit("ResetDotPayPaymentCounter");
      store.commit("SetDotPayPaymentLink", null);
    }

    await this.getMonthlySubscriptionData();

    let gusData = null;
    if (this.userData.vat)
      gusData = JSON.parse(
        JSON.stringify({ numType: "nip", numVal: this.userData.vat })
      );
    else
      gusData = JSON.parse(
        JSON.stringify({ numType: "regon", numVal: this.userData.regon })
      );

    await this.checkGusData(gusData.numType, gusData.numVal);
  },

  methods: {
    round2dec,

    calculatePayment(input) {
      this.additionalMonthsInfo = false;
      let result = null;

      if (this.orderContinuation === 0) {
        // + opłata aktywacyjna
        if (
          this.activationPricePromo === null ||
          this.activationPricePromo === undefined
        )
          result = this.round2dec(
            input * this.subscriptionPrice + this.activationPrice
          );
        else
          result = this.round2dec(
            input * this.subscriptionPrice + this.activationPricePromo
          );
      } else result = this.round2dec(input * this.subscriptionPrice);

      // TODO: do ustalenia czy będa jakieś promocje
      // if (input !== null && input !== "" && input % 6 === 0) { // dokładamy gratisowe miesiące - za każde 6 miesięcy miesiąc gratis?
      //   this.additionalMonthsInfo = true;
      //   this.expandMonths = input + (input / 6);
      // }

      this.paymentAmount = result;

      return result;
    },

    async getUserData() {
      let data = {
        action: this.request.GetUser,
      };
      let getUserResponse = await makeRequest(data);

      switch (getUserResponse.data.error) {
        case RequestResult.OK: {
          this.userData = getUserResponse.data.data;
          break;
        }
        case RequestResult.InvalidCookie:
        case RequestResult.CookieExpired: {
          this.$router.push(this.routePath.Login);
          break;
        }
        case RequestResult.GeneralError: {
          break;
        }
      }
    },

    async getDeviceData() {
      let data = {
        action: this.request.GetDeviceData,
      };
      let getUserSubscriptionDataResponse = await makeRequest(data);

      if (Array.isArray(getUserSubscriptionDataResponse.data.data))
        return getUserSubscriptionDataResponse.data.data;
      else return false;
    },

    async checkGusData(numType, numVal) {
      this.gusDataNotActive = false;
      this.gusDataError = false;

      let gusDataResult = true;
      let data = await makeRequest(
        `${this.hostname}?action=${this.request.BirData}&${numType}=${numVal}`,
        "GET"
      );

      switch (data.data.error) {
        case 0:
          if (!data.data.data.bir.active) {
            // wyświetl komunikat że dane nieaktualne i że trzeba je zweryfikować
            this.gusDataNotActive = true;
            gusDataResult = false;
          }
          break;
        default: {
          this.gusDataError = true; // błąd pobierania danych z GUSu
          gusDataResult = false;
        }
      }

      this.alertKey += 1;

      return gusDataResult;
    },

    async makeOrder() {
      let orderSuccess = false;
      let expandPeriod =
        this.expandMonths == null || this.expandMonths === ""
          ? this.expandPeriod
          : this.expandMonths;

      let data = {
        action: this.request.Order,
        userid: this.userId,
        serial:
          this.rentalDeviceSerialNumbers == null
            ? ""
            : this.rentalDeviceSerialNumbers.serialShort,
        price: this.paymentAmount,
        expandperiod: expandPeriod,
        continuation: this.orderContinuation, // 0 - z opłata aktywacyjna 1-bez opłaty aktywacyjnej
      };

      let makeOrderRequestResponse = await makeRequest(data);
      // console.log(JSON.stringify(makeOrderRequestResponse));

      switch (makeOrderRequestResponse.data.error) {
        case RequestResult.OK: {
          orderSuccess = true;
          let orderId = makeOrderRequestResponse.data.data.orderid;
          store.commit("SetOrderId", orderId);
          // zapisz dane do wygenerowania pro formy w bazie
          let fvitems =
            this.orderContinuation === 1
              ? JSON.stringify({
                  items: [
                    {
                      lp: 1,
                      nazwa:
                        "'Tester na wynajem' - wypożyczenie sprzętu + abonament",
                      ilosc: expandPeriod,
                      jm: "mies.",
                      cena_netto: this.subscriptionPrice,
                      vat: 23,
                    },
                  ],
                })
              : JSON.stringify({
                  items: [
                    {
                      lp: 1,
                      nazwa:
                        "'Tester na wynajem' - wypożyczenie sprzętu + abonament",
                      ilosc: expandPeriod,
                      jm: "mies.",
                      cena_netto: this.subscriptionPrice,
                      vat: 23,
                    },
                    {
                      lp: 2,
                      nazwa: "Opłata aktywacyjna",
                      ilosc: 1,
                      jm: "szt.",
                      cena_netto:
                        this.activationPricePromo === null ||
                        this.activationPricePromo === undefined ||
                        this.activationPricePromo === ""
                          ? this.activationPrice
                          : this.activationPricePromo,
                      vat: 23,
                    },
                  ],
                });
          await this.createAndSaveInvoiceOnServer(orderId, fvitems);
          break;
        }
        case RequestResult.InvalidCookie:
        case RequestResult.CookieExpired: {
          this.$router.push(this.routePath.Login);
          break;
        }
        case RequestResult.InvalidExpandPeriod: {
          this.invalidSubscriptionLength = true;

          this.subscriptionAvailableMonths = -1;
          if (makeOrderRequestResponse.data.hasOwnProperty('availableExpandMonths')) {
            this.subscriptionAvailableMonths = makeOrderRequestResponse.data.availableExpandMonths;
          }
          break;
        }
        default: {
          this.orderFailure = true;
        }
      }
      store.commit("SetOrderSuccess", orderSuccess);

      return makeOrderRequestResponse.data.error;
    },

    async createAndSaveInvoiceOnServer(orderId, fv_items) {
      let data = {
        action: this.request.CreateAndSaveInvoice,
        fv_orderNumber: orderId,
        fv_items: fv_items,
      };

      let invoiceRequestResponse = await makeRequest(data);

      switch (invoiceRequestResponse.data.error) {
        case RequestResult.OK: {
          // zamówione złożone, proforma utworzona, w sumie to jest ok i można wyświetlć komunikat że zamówienie złożone
          // idziemy dalej ale to już jak makeOrder zwróciło OK i Promise jest prawidłowy (w onExtendSubscriptionButtonClick)
          break;
        }
        case RequestResult.GeneralError: {
          this.orderFailure = true;
          break;
        }
        case RequestResult.InvalidCookie:
        case RequestResult.CookieExpired: {
          this.$router.push(this.routePath.Login);
          break;
        }
      }
    },

    showOrderSuccessInfo() {
      if (this.paymentChoice === "traditionalTransfer") {
        store.commit("SetTraditionalTransfer", true);
        store.commit("SetDotPay", null);
      }

      let orderAmount = this.round2dec(this.paymentAmount * this.vatRatio);

      if (this.paymentChoice === "dotPay") {
        store.commit("SetDotPay", true);
        store.commit("SetOrderAmount", orderAmount);
        store.commit("SetTraditionalTransfer", null);
      }

      this.$router.push(this.routePath.OrderInfo);
    },

    onBackButtonClick() {
      this.$router.push(this.routePath.Home);
    },

    onExtendSubscriptionButtonClick(event) {
      event.preventDefault();

      this.orderFailure = null;
      store.commit("SetOrderState", null); // resetuję orderState przed wykonaniem właściwego Order

      if (this.userDataAgreement) {
        this.makeOrder().then((result) => {
          if (result === RequestResult.OK) {
            this.showOrderSuccessInfo();
          } else if (RequestResult.InvalidExpandPeriod) {
            this.orderFailure = false;
          }
        });
      }
    },

    async getMonthlySubscriptionData() {
      let getMonthlySubscriptionDataResponse = await makeRequest(
        this.hostname + `?action=${this.request.GetMonthlySubscriptionData}`,
        "GET"
      );

      switch (getMonthlySubscriptionDataResponse.data.error) {
        case RequestResult.OK: {
          this.subscriptionPrice =
            getMonthlySubscriptionDataResponse.data.data.subscription_rental_1m;
          //this.subscriptionDays =
            //getMonthlySubscriptionDataResponse.data.data.subscription_days_1m;
          this.activationPrice =
            getMonthlySubscriptionDataResponse.data.data.subscription_rental_activ_fee;
          this.activationPricePromo =
            getMonthlySubscriptionDataResponse.data.data.subscription_rental_activ_fee_promo;
          break;
        }
        case RequestResult.GeneralError: {
          break;
        }
        case RequestResult.InvalidCookie:
        case RequestResult.CookieExpired: {
          this.$router.push(this.routePath.Login);
          break;
        }
      }
    },

    invalidSubscriptionLengthAlertText() {
      if (this.subscriptionAvailableMonths >= 0)
        return "Minimalna długość abonamentu to jeden miesiąc. Długość abonamentu nie może przekraczać 12 miesięcy! Maksymalna dostępna liczba miesięcy: " + this.subscriptionAvailableMonths + "."
      else
        return "Minimalna długość abonamentu to jeden miesiąc. Długość abonamentu nie może przekraczać 12 miesięcy!";
    }
  },
};
</script>

<style scoped>
.tile p {
  text-align: left;
  font-size: 15px;
  line-height: 15px;
}

.align-center {
  margin-left: auto;
  margin-right: auto;
  width: max-content;
}

#payment_calculation p {
  text-align: center;
}

#payment_choose p {
  line-height: 25px;
}
</style>
